import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  backgroundColor,
  flex,
  flexDirection,
  minWidth,
  position,
  space,
  width,
} from 'styled-system';

import { boxSizing } from '../../theme/system-utilities';

const UnstyledSearchFormContainer = styled.div<any>`
  ${position};
  ${flex};
  ${flexDirection};
  ${width};
  ${minWidth};
  ${space};
  ${boxSizing};
  ${backgroundColor};
  transition-property: top, transform, opacity, background-color;
  transition-timing-function: ease-in-out;

  ${({ transitionState }) =>
    transitionState !== 'exited' &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999999;
    `};

  ${({ transitionState, timeout }) =>
    ['entering', 'entered'].includes(transitionState) &&
    css`
      background-color: white;
      transition-duration: ${timeout}ms;
    `};

  ${({ transitionState, timeout }) =>
    transitionState !== 'entering' &&
    css`
      transition-duration: ${timeout}ms;
      transition-delay: ${timeout}ms;
    `};
`;

const SearchFormContainer = (props: ComponentProps<typeof UnstyledSearchFormContainer>) => (
  <UnstyledSearchFormContainer
    position={['static', 'relative']}
    flexDirection="column"
    width={1}
    my={0}
    mx="auto"
    boxSizing="border-box"
    backgroundColor="transparent"
    {...props}
  />
);

export default SearchFormContainer;
